module.exports = __webpack_public_path__ + "assets/img/home-characterC.bd0415b7.png";